module.exports = __webpack_public_path__ + "static/media/fw4.e733c24f.pdf";